const deleteCacheErrorMessage = "Oops, Content Cache cannot be cleared. (It might be cleared already or please contact support for help)";

const deleteCacheMessages = responseData => (responseData && responseData.message
  ? responseData.message : deleteCacheErrorMessage);

export {
  // eslint-disable-next-line import/prefer-default-export
  deleteCacheMessages,
};
